export type MobileAppConfig = {
  /** Stable id used as React key */
  id: string;
  /** Display name shown on the status page */
  name: string;
  /** App Store bundle id, e.g. app.primio.v2 */
  iosBundleId?: string;
  /** Play Store package id, e.g. app.primio.v2 */
  androidPackageId?: string;
};

/**
 * Primio + whitelabel mobile apps to monitor.
 * Add entries with the relevant store ids (ios and/or android).
 */
export const MOBILE_APPS: MobileAppConfig[] = [
  {
    id: "primio",
    name: "Primio",
    iosBundleId: "app.primio.v2",
    androidPackageId: "app.primio.v2",
  },
  {
    id: "zorgexpeditie",
    name: "ZorgExpeditie",
    iosBundleId: "app.primio.zorgexpeditie",
    androidPackageId: "app.primio.zorgexpeditie",
  },
  {
    id: "veiligheidsregio-kennis-app",
    name: "Veiligheidsregio kennis-app",
    iosBundleId: "app.primio.veiligheidsregio",
    androidPackageId: "app.primio.veiligheidsregio",
  },
  {
    id: "hups",
    name: "Hups Academy",
    iosBundleId: "app.primio.hups",
    androidPackageId: "app.primio.hups",
  },
  {
    id: "humio",
    name: "Humio",
    iosBundleId: "app.primio.humio",
    androidPackageId: "app.primio.humio",
  },
  {
    id: "bsl-nursing",
    name: "Nursing",
    iosBundleId: "app.primio.bsl.nursing",
    androidPackageId: "app.primio.bsl.nursing.bsl",
  },
  {
    id: "bsl-kinderopvang",
    name: "KOT Wijzer",
    iosBundleId: "app.primio.bsl.kinderopvang",
    androidPackageId: "app.primio.bsl.kinderopvang",
  },
];
